import { useContext } from 'react'

import { AddActionDialog } from '@pages/EntityCreateOrEdit'
import { PageContext } from '@pages/TimeLineCreateOrEdit/TimeLineCreateOrEdit'

import { CATEGORIES, ENTITY_TYPES_REQUEST } from '@constants'
import { ActionRow } from '@types'

import { getObjectXActionDialogMeta } from '../../helpers'

export const ObjectXAddActionDialog = () => {
  const { handlers, state, data } = useContext(PageContext)

  const { handleSaveTimeLine, handleCloseObjectXAddActionDialog, handleChangeObjectXAction } =
    handlers

  const {
    objectXAddActionDialogData,
    objectXShowAddActionDialog,
    watchId,
    isCreateOrUpdateLoading,
    watchMode,
  } = state

  const {
    objectXSelectedColumnsObjectFields,
    objectXSelectedObjectFields,
    objectYSelectedObjectFields,
  } = data

  const handleCreateAction = (data: ActionRow) => {
    handleChangeObjectXAction(data)

    return handleSaveTimeLine()
  }

  const handleEditAction = (data: ActionRow) => {
    handleChangeObjectXAction(data)

    return handleSaveTimeLine()
  }

  if (!objectXAddActionDialogData) {
    return null
  }

  return (
    <AddActionDialog
      isDisableActionEventsFiltering
      actionEventsCategoryCode={objectXAddActionDialogData.actionEventsCategoryCode}
      actionTable={objectXAddActionDialogData.actionTable}
      bindingValuesAction={objectXAddActionDialogData.bindingValuesAction}
      columns={[]}
      createAction={handleCreateAction}
      currentRow={objectXAddActionDialogData.currentRow}
      editAction={handleEditAction}
      isActionLoading={isCreateOrUpdateLoading}
      modalType={objectXAddActionDialogData.modalType}
      objectCode={objectXAddActionDialogData.objectCode}
      showDialog={objectXShowAddActionDialog}
      tooltipEventsCategoryCode={CATEGORIES.BINDING_TIME_TABLE_OBJECT_X_EVENTS_ACTION_TOOLTIP}
      type={ENTITY_TYPES_REQUEST.TIME_TABLE}
      contextMenuEventsCategoryCode={
        CATEGORIES.BINDING_TIME_TABLE_OBJECT_Y_CONTEXT_MENU_EVENT_ACTION
      }
      meta={getObjectXActionDialogMeta({
        watchMode,
        objectXSelectedObjectFields,
        objectYSelectedObjectFields,
        objectXSelectedColumnsObjectFields,
      })}
      variablesConfig={{
        entityType: ENTITY_TYPES_REQUEST.TIME_TABLE,
        entityId: watchId,
      }}
      onCloseModal={handleCloseObjectXAddActionDialog}
    />
  )
}
